module.exports = __webpack_public_path__ + "img/wizard-04@2x.b9748a73.png";